module.exports = __webpack_public_path__ + "img/pausa.880c1ec7.png";